import Vue from 'vue'
import VueRouter from 'vue-router'
import loginRoutes from '@/router/login'
import dashboardRoutes from '@/router/dashboard'
import userRoutes from '@/router/users'
import companiesRoutes from '@/router/companies'
import statusesRoutes from '@/router/statuses'
import typesRoutes from '@/router/types'
import taxesRoutes from '@/router/taxes'
import productsRoutes from '@/router/products'
import budgetsRoutes from '@/router/budgets'
import workflowsRoutes from '@/router/workflows'
import clientsRoutes from '@/router/clients'
import groupsRoutes from '@/router/groups'
import accountRoutes from '@/router/account'
import error404 from '@/views/errors/error404'

Vue.use(VueRouter)

export default new VueRouter({
    mode: 'history',
    linkExactActiveClass: 'active',
    routes: [
      ...loginRoutes,
      ...dashboardRoutes,
      ...userRoutes,
      ...companiesRoutes,
      ...statusesRoutes,
      ...groupsRoutes,
      ...typesRoutes,
      ...taxesRoutes,
      ...productsRoutes,
      ...clientsRoutes,
      ...budgetsRoutes,
      ...workflowsRoutes,
      ...accountRoutes,
      {
        path: '/404',
        name: 'error404',
        component: error404,
        meta: {
          layout: 'error'
        }
      },
      {
        path: '*',
        redirect: 'login'
      }  
    ]  
})